/*
 File I use to map navigation structure between pages
*/

function allowNotLoggedInForPath (tenantName, path) {
  // All pages require login accept profile which may be public
  if (path === '/pagenotfound') {
    return true
  }
  if (path === '/' + tenantName) {
    return true
  }
  if (path === '/' + tenantName + '/') {
    return true
  }
  if (path === '/' + tenantName + '/debug') {
    return true
  }
  if (path === '/' + tenantName + '/about') {
    return true
  }
  if (path === '/' + tenantName + '/cssp') {
    return true
  }
  if (path === '/' + tenantName + '/privacy') {
    return true
  }
  if (path === '/' + tenantName + '/tos') {
    return true
  }
  if (path === '/' + tenantName + '/values') {
    return true
  }
  if (path === '/' + tenantName + '/organiserfeatures') {
    return true
  }
  if (path === '/' + tenantName + '/profile/deleteaccount') {
    return true
  }
  if (path === '/' + tenantName + '/profile/deleteaccountconfirm') {
    return true
  }
  if (path === '/' + tenantName + '/copyright') {
    return true
  }
  if (typeof (path) === 'undefined') {
    console.log('RJMDEBUG001 ERROR - path is not defined when passed in call to navigation structure')
  }
  const pathArr = path.split('/')
  if (pathArr.length === 4 && path.startsWith('/' + tenantName + '/clubs/')) {
    return true
  }
  if (pathArr.length === 5 && path.startsWith('/' + tenantName + '/promo/')) {
    // public page for event (if it is public)
    return true
  }
  // promoreg - must be logged in for this page
  return false
}

function navigateToParent (router, overrideParentPath) {
  // Where we can use explicit routing
  if (typeof (overrideParentPath) !== 'undefined') {
    router.replace('/' + router.currentRoute.value.params.tenantName + overrideParentPath)
    return
  }
  const currentpath = router.currentRoute.value.path
  if (currentpath.startsWith('/' + router.currentRoute.value.params.tenantName + '/promo/')) {
    router.replace('/' + router.currentRoute.value.params.tenantName + '/clubs/' + router.currentRoute.value.params.clubId)
    return
  }
  if (currentpath.startsWith('/' + router.currentRoute.value.params.tenantName + '/chatroom/')) {
    router.replace('/' + router.currentRoute.value.params.tenantName + '/')
    return
  }
  if (currentpath.startsWith('/' + router.currentRoute.value.params.tenantName + '/chatroom')) {
    router.replace('/' + router.currentRoute.value.params.tenantName + '/')
    return
  }
  if (currentpath.startsWith('/' + router.currentRoute.value.params.tenantName + '/profile/deleteaccountconfirm')) {
    router.replace('/' + router.currentRoute.value.params.tenantName + '/')
    return
  }
  if (currentpath.startsWith('/' + router.currentRoute.value.params.tenantName + '/clubs/')) {
    // we are in a club with an id
    router.replace({
      name: 'Clubs',
      params: {
        tenantName: router.currentRoute.value.params.tenantName
      }
    })
    return
  }
  function stripAfterLastSlash (str) {
    return str.substring(0, str.lastIndexOf('/'))
  }
  router.replace(stripAfterLastSlash(currentpath))
}

export default {
  allowNotLoggedInForPath,
  navigateToParent
}
